import { Box, Heading, Tag } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useCustomCategories } from "../context/CustomCatgoriesContext";

const CustomCategoriesTags = () => {
  const { categories, deleteCategory } = useCustomCategories();
  const [, setHasAnimated] = useState(false);

  useEffect(() => {
    setHasAnimated(true);
  }, []);

  const handleDelete = (index: number) => {
    const updated = [...categories];
    updated.splice(index, 1);
    localStorage.setItem("customCategories", JSON.stringify(updated));
    deleteCategory(index);
  };

  return (
    <Box maxW="3xl" mx="auto" mt={2}>
      <Heading size="lg" mb={4} textAlign="center">
        Alle Kategorien
      </Heading>
      <Box gap="20" border={"1px solid gray"} p={4} borderRadius={4}>
        {categories.map((item, index) => (
          <Tag.Root mr={2} mb={2} size={"lg"}>
            <Tag.Label>{item.label}</Tag.Label>
            <Tag.EndElement>
              <Tag.CloseTrigger
                onClick={() => handleDelete(index)}
                _hover={{ cursor: "pointer" }}
              />
            </Tag.EndElement>
          </Tag.Root>
        ))}
      </Box>
    </Box>
  );
};

export default CustomCategoriesTags;
